var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
export class TemplatesSortingDropdown extends PureComponent {
    handleSortByNameAsc() {
        this.templatesSortChange('name:asc');
    }
    handleSortByNameDesc() {
        this.templatesSortChange('name:desc');
    }
    handleSortByCreatedAtAsc() {
        this.templatesSortChange('created_at:asc');
    }
    handleSortByCreatedAtDesc() {
        this.templatesSortChange('created_at:desc');
    }
    handleSortByLastEditedAtAsc() {
        this.templatesSortChange('last_edited_at:asc');
    }
    handleSortByLastEditedAtDesc() {
        this.templatesSortChange('last_edited_at:desc');
    }
    templatesSortChange(sortBy) {
        this.props.templatesParamsChange({
            sort_by: sortBy,
        });
    }
    render() {
        const { className, disabled } = this.props;
        return (_jsx(DropdownButton, Object.assign({ className: className, buttonProps: { disabled }, dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: this.handleSortByNameAsc }, { children: "A - Z" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: this.handleSortByNameDesc }, { children: "Z - A" })), _jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: this.handleSortByCreatedAtAsc }, { children: "Created first" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: this.handleSortByCreatedAtDesc }, { children: "Created last" })), _jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: this.handleSortByLastEditedAtAsc }, { children: "Updated first" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: this.handleSortByLastEditedAtDesc }, { children: "Updated last" }))] }) }, { children: "Sort by" })));
    }
}
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByNameAsc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByNameDesc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByCreatedAtAsc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByCreatedAtDesc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByLastEditedAtAsc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "handleSortByLastEditedAtDesc", null);
__decorate([
    boundMethod
], TemplatesSortingDropdown.prototype, "templatesSortChange", null);
